import React from 'react';
import { Link } from 'react-router-dom';

import { getClickAttrs } from '../../Analytics/gtag';

import { clickLocations } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';

import TrackedClick from '../../Analytics/TrackedClick';

const DesktopButton = ({ label, navId, to, onClick, className, 'data-testid': dataTestId }) => {
    return (
        <TrackedClick
            eventName={`${label} Clicked`}
            label={label}
            traits={{
                pageLocation: clickLocations.HEADER_CTA,
                uxType: 'button',
                content: label,
            }}
        >
            <Link
                className={className}
                onClick={onClick}
                to={to}
                data-testid={dataTestId}
                {...getClickAttrs({
                    category: label,
                    context: `${label} button click`,
                    location: clickLocations.HEADER_CTA,
                    testid: `${navigationIDs[navId].component}-${navigationIDs[navId].location}-${navigationIDs[navId].id}`,
                })}
            >
                {label}
            </Link>
        </TrackedClick>
    );
};

export default DesktopButton;
